import Head from "next/head";
import { Fragment, useState, useEffect } from "react";
import { Announcement, Feedback, Share, Error, ScheduleField, ImageDropdown, Navbar, Source, AuthenticationRequired, Footer } from "../components";
import firstdark from "../images/firstdark.png";
import seconddark from "../images/seconddark.png";
import firstwhite from "../images/firstwhite.png";
import secondwhite from "../images/secondwhite.png";
import firstprint from "../images/firstprint.png";
import secondprint from "../images/secondprint.png";

export default function Home() {
	const [data, setData] = useState(null);
	const [msg, setMsg] = useState("");
	const [error, setError] = useState(null);
	const [status, setStatus] = useState(null);
	const [imageIndex, setImageIndex] = useState(0);
	const [defaultStatus, setDefaultStatus] = useState(firstdark);
	const [imageList, setImageList] = useState([null, null, null, null, null, null, null]);
	const [darkTheme, setDarkTheme] = useState(false);
	const [floor, setFloor] = useState(1);
	const [floorSwitch, setFloorSwitch] = useState(false);

	const [errorMsg, setErrorMsg] = useState(false);

	const [feedbackOpen, setFeedbackOpen] = useState(false);
	const [feedbackStatus, setFeedbackStatus] = useState(null);

	const [shareOpen, setShareOpen] = useState(false);
	const [shareURL, setShareURL] = useState("");
	const [shareMsg, setShareMsg] = useState("");

	const [roomCount, setRoomCount] = useState([...Array(7)]);

	useEffect(() => {
		setTimeout(() => {
			setMsg("");
			setStatus(null);
		}, 500);
		let dark = window.matchMedia("(prefers-color-scheme: dark)").matches;
		setDarkTheme(dark);
		if (dark) setDefaultStatus(floor == 1 ? firstdark : seconddark);
		else setDefaultStatus(floor == 1 ? firstwhite : secondwhite);
	}, [floor]);

	function openModal() {
		if (feedbackStatus == "Thanks for your feedback!") setFeedbackStatus(null);
		setFeedbackOpen(true);
	}

	async function feedback(event) {
		event.preventDefault();
		if (!event.target.feedback.value) return setFeedbackStatus("Comment Is Required");
		if (event.target.email.value && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.email.value)) return setFeedbackStatus("Invalid Email");
		setFeedbackStatus("Processing");
		const json = await fetch(`${process.env.NEXT_PUBLIC_WEBSITE}/api/feedback`, {
			method: "POST",
			body: JSON.stringify({ feedback: event.target.feedback.value, email: event.target.email.value }),
		}).then((res) => res.json());
		console.log(`DEBUG: ${JSON.stringify(json)}`);
		setTimeout(() => {
			setFeedbackStatus("Thanks for your feedback!");
			event.target.feedback.value = "";
		}, 1000);
	}

	async function submit(event) {
		event.preventDefault();
		if (!event.target["1"].value) return setError("Period 1 is required.");
		let newImageList = [];
		let query = `?1=${event.target["room-1"].value}`;

		for (let i = 0; i < roomCount.length; i++) {
			if (!event.target[`room-${i + 2}`].value) {
				return setError(`Period ${i + 2} is required.`);
			}
			query += `&${i + 2}=${event.target[`room-${i + 2}`].value}`;
			newImageList.push(`${process.env.NEXT_PUBLIC_WEBSITE}/api/path?start=${event.target[`room-${i + 1}`].value}&end=${event.target[`room-${i + 2}`].value}&dark=${darkTheme}`);
		}
		console.log(`DEBUG: Total Length: ${totalLength}`);
		setShareURL(`${process.env.NEXT_PUBLIC_WEBSITE}/sharemap${query}`);
		setShareMsg(`Checkout the best route for my schedule!`);
		setError(false);
		setMsg("Calculating shortest route.");
		setStatus("Processing");
		let totalLength = 0;
		for (let i = 0; i < roomCount.length; i++) {
			totalLength += await fetch(`${process.env.NEXT_PUBLIC_WEBSITE}/api/length?start=${event.target[`room-${i + 1}`].value}&end=${event.target[`room-${i + 2}`].value}`).then((res) => res.json());
		}
		setImageIndex(0);
		setImageList(newImageList);
		const pre = await fetch(`${process.env.NEXT_PUBLIC_WEBSITE}/api/pre?start=${event.target["room-1"].value}&end=${event.target["room-2"].value}`).then((res) => res.json());
		setFloor(pre.startingFloor);
		console.log(`[DEBUG] Setting starting floor to ${pre.startingFloor}.`);
	}

	async function share() {
		if (navigator.share) {
			navigator
				.share({
					title: "John Jay Senior High School Route Calculator",
					text: shareMsg,
					url: shareURL,
				})
				.then(() => {})
				.catch((err) => {
					if (err.message !== "Abort due to cancellation of share.") {
						setErrorMsg(err.message);
					}
				});
		} else {
			setShareOpen(true);
		}
	}

	if (!data) return <AuthenticationRequired setData={setData} />;
	return (
		<div className="">
			<Head>
				<title>John Jay Map</title>
				<Source />
				<link href="/jquery.flexdatalist.min.css" rel="stylesheet" type="text/css" />
				<link href="/main.css" rel="stylesheet" type="text/css" />
				<script src="/flexdatalist.min.js"></script>
				<script src="/main.js"></script>
			</Head>
			<Announcement openModal={openModal} />
			<Navbar page={"schedule"} openFeedback={openModal} data={data} />
			<div className="better-100vh flex items-center bg-white pt-4 dark:bg-gray-900 md:pt-0">
				<div className="container mx-auto grid grid-cols-1 content-center lg:grid-cols-2 xl:grid-cols-3  ">
					<div className="my-auto mx-auto w-full text-center">
						<div className="">
							<h1 className="my-3 text-3xl font-semibold text-gray-700 dark:text-gray-200">JJHS Mapping Software</h1>
							<p className="text-gray-500 dark:text-gray-400">
								{/*{(msg == "share" && shareURL!=="") && <>
                  <button type="button" id="share-btn" onClick={share} className="text-indigo-500 focus:outline-none focus:underline focus:text-indigo-500 focus:border-indigo-800">Share this map with a friend!</button>
                </>}
                {(msg && msg !== "share") && <>
                  {msg}
                </>}
                {(!msg) && <>
                  Enter your enter schedule to continue.
                </>}*/}
								{msg ? msg : "Enter your schedule to continue."}
							</p>
							<div className="m-7">
								<form onSubmit={submit}>
									<div className="mb-6">
										<div class="grid grid-cols-8 gap-4">
											<div class="col-span-2 my-auto text-right md:col-span-1 lg:col-span-2">
												<label htmlFor="text" className="block text-sm text-gray-600 dark:text-gray-400">
													Period 1
												</label>
											</div>
											<div class="col-span-6 md:col-span-3 lg:col-span-6">
												<input
													type="text"
													placeholder="Enter a room number."
													name="room-1"
													id="room-1"
													data-visible-properties='["room", "subject"]'
													data-search-by-word="true"
													data-data={`/api/data/all`}
													data-search-in='["room","subject"]'
													data-text-property="{room}"
													data-value-property="id"
													data-min-length="0"
													data-selection-required="true"
													data-search-delay="0"
													data-cache-lifetime="0"
													className="flexdatalist w-full rounded-md border border-gray-300 px-3 py-2 placeholder-gray-300 focus:border-indigo-300 focus:outline-none focus:ring focus:ring-indigo-100 disabled:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:focus:border-gray-500 dark:focus:ring-gray-900 dark:disabled:bg-gray-800"
												/>
											</div>
											{roomCount.map((_, index) => (
												<ScheduleField id={index + 2} last={index == roomCount.length - 1} roomCount={roomCount} setRoomCount={setRoomCount} />
											))}
										</div>
									</div>
									<div className="mb-6">
										{status !== "Processing" && (
											<>
												<button type="submit" className={"pointer-events-auto w-full rounded-md bg-indigo-700 px-3 py-3 text-white hover:bg-indigo-600 focus:outline-none"}>
													{status ? status : "Generate Map"}
												</button>
											</>
										)}
										{status == "Processing" && (
											<>
												<button type="button" className="inline-flex w-full cursor-wait justify-center rounded-md bg-indigo-600 px-3 py-3 text-white focus:outline-none ">
													<svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
														<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
														<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
													</svg>
												</button>
											</>
										)}
										{error && (
											<>
												<p className="mt-3 text-center text-sm text-gray-400">{error}</p>
											</>
										)}
										{!error && status == "Generate Map" && (
											<>
												<p className="mt-3 text-center text-sm text-gray-400">
													How'd we do?{" "}
													<button type="button" onClick={openModal} className="text-indigo-500 focus:border-indigo-800 focus:text-indigo-500 focus:underline focus:outline-none">
														Let us know!
													</button>
												</p>
											</>
										)}
										{!error && status !== "Generate Map" && (
											<>
												<p className="mt-3 text-center text-sm text-gray-400">
													Want to calculate a single route instead?{" "}
													<button
														type="button"
														onClick={() => {
															location.href = "/landing";
														}}
														className="text-indigo-500 focus:border-indigo-800 focus:text-indigo-500 focus:underline focus:outline-none"
													>
														We can do that!
													</button>
												</p>
											</>
										)}
									</div>
								</form>
							</div>
						</div>
					</div>

					<div className="col-span-1 md:my-10 xl:col-span-2">
						{/*<div class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-2 mb-4">
              {imageList.map((theImage, index)=>{
                return <><button onClick={() => {setImageIndex(index)}} className={"px-3 py-3 text-white rounded-md focus:outline-none " + (theImage == "/api/basic?theme=light" ? "bg-indigo-800 pointer-events-none" :(index != imageIndex ? "bg-indigo-800 hover:bg-indigo-700" : "bg-indigo-600 pointer-events-auto"))}>Period {index+1} to {index+2}</button></>
              })}
            </div>*/}
						<div class="mb-4 hidden flex-wrap content-center md:flex">
							{imageList.map((theImage, index) => {
								return (
									<>
										<button
											onClick={() => {
												setImageIndex(index);
											}}
											className={
												"whitespace-no-wrap my-1 mx-1 flex-auto rounded-md px-3 py-3 text-white focus:outline-none " +
												(theImage == "/api/basic?theme=light" || theImage == "/api/basic?theme=dark"
													? "pointer-events-none bg-indigo-800"
													: index != imageIndex
													? "bg-indigo-800 hover:bg-indigo-700"
													: "pointer-events-auto bg-indigo-600")
											}
										>
											Period {index + 1} to {index + 2}
										</button>
									</>
								);
							})}
						</div>
						<div class="m-4 content-center md:hidden">
							<ImageDropdown imageIndex={imageIndex} setImageIndex={setImageIndex} imageList={imageList} />
						</div>
						{imageList.map((theImage, index) => {
							return (
								<>
									{/*<img src={theImage} className={"w-full " + (theImage == image) ? "display" : "hidden"} onLoad = {() => {setStatus("Generate Map"); setMsg("share")}}/>*/}
									<img
										src={theImage ? theImage + `&floor=${floor}` : `/_next/image?url=${defaultStatus.src}&w=3840&q=75`}
										className={"mb-20 w-full md:mb-0 " + (index == imageIndex ? "" : "hidden")}
										onLoad={() => {
											setStatus("Generate Map");
											setFloorSwitch(false);
										}}
									/>
								</>
							);
						})}
						<div className="mx-4 grid grid-cols-1 content-center gap-4 lg:grid-cols-5">
							{floorSwitch !== 1 && (
								<>
									<button
										type="button"
										onClick={() => {
											setFloor(1);
											setFloorSwitch(1);
										}}
										className={
											"w-full rounded-md px-3 py-3 text-white focus:outline-none lg:col-span-2 " +
											(floor == 1 ? "pointer-events-none bg-indigo-600" : "pointer-events-auto bg-indigo-800 hover:bg-indigo-700")
										}
									>
										First Floor
									</button>
								</>
							)}
							{floorSwitch == 1 && (
								<>
									<button
										type="button"
										className={
											"inline-flex w-full cursor-wait justify-center rounded-md bg-indigo-600 px-3 py-3 text-white focus:outline-none lg:col-span-2 " +
											(floor == 1 ? "bg-indigo-600" : "bg-indigo-800 hover:bg-indigo-700")
										}
									>
										<svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
											<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
									</button>
								</>
							)}
							{floorSwitch !== 2 && (
								<>
									<button
										type="button"
										onClick={() => {
											setFloor(2);
											setFloorSwitch(2);
										}}
										className={
											"w-full rounded-md px-3 py-3 text-white focus:outline-none lg:col-span-2 " +
											(floor == 2 ? "pointer-events-none bg-indigo-600" : "pointer-events-auto bg-indigo-800 hover:bg-indigo-700")
										}
									>
										Second Floor
									</button>
								</>
							)}
							{floorSwitch == 2 && (
								<>
									<button
										type="button"
										className={
											"inline-flex w-full cursor-wait justify-center rounded-md bg-indigo-600 px-3 py-3 text-white focus:outline-none lg:col-span-2 " +
											(floor == 2 ? "bg-indigo-600" : "bg-indigo-800 hover:bg-indigo-700")
										}
									>
										<svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
											<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
									</button>
								</>
							)}
							<button
								type="button"
								onClick={() => {
									window.open(
										imageList[imageIndex]
											? imageList[imageIndex] + `&floor=${floor}&dark=print`
											: floor == 1
											? `/_next/image?url=${firstprint.src}&w=3840&q=75`
											: `/_next/image?url=${secondprint.src}&w=3840&q=75`,
										"_blank"
									);
								}}
								className={"pointer-events-auto w-full rounded-md bg-indigo-800 px-3 py-3 text-white hover:bg-indigo-700 focus:outline-none"}
							>
								Print
							</button>
						</div>
					</div>
					<Feedback feedbackStatus={feedbackStatus} isOpen={feedbackOpen} feedback={feedback} setIsOpen={setFeedbackOpen} data={data} />
					<Share isOpen={shareOpen} setIsOpen={setShareOpen} url={shareURL} />
					<Error msg={errorMsg} setIsOpen={setErrorMsg} />
				</div>
			</div>
			<Footer />
		</div>
	);
}
